import React, { useEffect, useCallback, useState} from 'react';
import PresetOption from "components/installation/PresetOption.js";
import {searchPresets} from "decentralized/presets/PresetsSearcher.js"
import Colors from "components/Colors.js";
import {connect} from 'react-redux';

const colors = new Colors();

const PackPresets = ({
    isPianoRoll,
    pack,
    instrumentType,
    filterFavorites,
    guildId,
    scrollRef,
    content,
    _auditionPreset,
    setPresetDragging,
    searchTerm
}) => { 
    
    let [showing, setShowing] = useState(false);
    let [presets, setPresets] = useState([]);

    useEffect(() => {
        if (searchTerm && searchTerm !== "") {
            setShowing(true);
        } else {
            setShowing(false);
        }
    }, [searchTerm, setShowing]);

    useEffect(() => {
        if (showing) {
            searchPresets(
                undefined,
                instrumentType,
                [],
                guildId,
                undefined,
                filterFavorites,
                pack.matchingContent
            ).then((e) => {
                setPresets(e);
            });
        } else {
        }
    }, [showing, setPresets, pack]);

    const color = colors.getColorForHash(pack.title);
    let style = {};
    //if (showing) {
        style.backgroundColor = color;
    //} else {
    /*
        style.borderStyle = 'solid';
        style.borderWidth = '1px';
        style.borderColor = color;
    }
    */
    return (
        <div className="pack-presets">
          <div
            onClick={() => setShowing(!showing)}
            className="pack-header">
            <div style={style} className="pack-thumb"/>
            <div className="pack-name">{pack.title}</div>
          </div>
          {showing ? presets.map(
              (preset, i) => 
                  <PresetOption
                    key={i}
                    isPianoRoll={isPianoRoll}
                    preset={preset}
                    scrollRef={scrollRef}
                    currentPreset={content}
                    setPresetDragging={setPresetDragging}
                    _auditionPreset={_auditionPreset}
                  />) : ''}
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PackPresets);
